import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS - 3);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: hours,
    suffix: 'hrs'
  }, {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-ink text-white" data-id="element-34" data-mp="ant8i1dy1vw4">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-4 py-2 text-[11px] font-bold uppercase tracking-[0.14em] sm:text-xs" data-id="element-35" data-mp="6nisdvwftp3j">
        <HourglassIcon className="h-3.5 w-3.5 text-cta" aria-hidden="true" data-id="element-36" data-mp="13cftikc8opaw" />
        <span className="text-white/80" data-id="element-37" data-mp="18e51fr460mur">Launch offer ends in:</span>
        <span className="flex items-center gap-1 tabular-nums" aria-live="off" data-id="element-38" data-mp="udlz90mdsb0i">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-1" data-id="element-39" data-mp="ye5xy8mlrmor" data-mpi={index}>
              <span className="text-sm font-extrabold text-cta sm:text-base" data-id="element-40" data-mp="1m4s4fvgykywn">
                {pad(unit.value)}
              </span>
              <span className="text-[9px] tracking-normal text-white/60" data-id="element-41" data-mp="1r2jwqqlimn1d">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="px-0.5 text-white/40" data-id="element-42" data-mp="1hda150rgqm8i">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}